import React, { FC } from 'react';
import styled from 'styled-components';

type FlexDirection = 'column' | 'column-reverse' | 'row' | 'row-reverse';
type FlexAlign = 'center' | 'start' | 'end' | 'stretch';
type FlexJustify =
	| 'center'
	| 'start'
	| 'flex-end'
	| 'space-between'
	| 'space-around'
	| 'stretch'
	| 'space-evenly';
type FlexWrap = 'wrap' | 'nowrap' | 'wrap-reverse';

interface Props {
	direction?: FlexDirection;
	align?: FlexAlign;
	justify?: FlexJustify;
	wrap?: FlexWrap;
	children?: React.ReactNode;
	gap?: number;
	width?: string;
	height?: string;
	marginTop?: string;
	position?: string;
	paddingTop?: string;
}

const StyledFlex = styled.div<Props>`
	position: ${({ position }) => position ?? 'static'};
	display: flex;
	flex-direction: ${({ direction }) => direction ?? 'row'};
	align-items: ${({ align }) => align ?? 'stretch'};
	justify-content: ${({ justify }) => justify ?? 'stretch'};
	flex-wrap: ${({ wrap }) => wrap ?? 'nowrap'};
	gap: ${({ gap }) => gap ?? 0}px;
	width: ${({ width }) => width ?? '100%'};
	height: ${({ height }) => height ?? '100%'};
	margin-top: ${({ marginTop }) => marginTop ?? '0'};
	padding-top: ${({ paddingTop }) => paddingTop ?? '0'};
`;

export const Flex: FC<Props> = props => {
	return <StyledFlex {...props}>{props.children}</StyledFlex>;
};
